// src/components/StoreTicker.js
import React, { useEffect, useRef } from 'react';

const StoreTicker = () => {
  const tickerRef = useRef(null);

  useEffect(() => {
    const ticker = tickerRef.current;
    let animationId;
    let position = 0;

    const animate = () => {
      position -= 1; // Speed of scrolling
      if (ticker) {
        // Reset position when content has scrolled completely
        if (position <= -ticker.scrollWidth / 2) {
          position = 0;
        }
        ticker.style.transform = `translateX(${position}px)`;
      }
      animationId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, []);

  const messages = [
    "🌟 Trusted by 10000+ Pakistani Parents",
    "🧸 Toddlers Up to 20% Off",
    "✅ 100% Satisfaction Guarantee",
    "💰 Cash on Delivery",
    "🚚 Delivery with in a Weak Across Pakistan",
    "📚 Learning Packs for Ages 2-4",
    "⭐ Trusted by 10000+ Pakistani Parents",
  ];

  // Duplicate messages for seamless scrolling
  const allMessages = [...messages, ...messages];

  return (
    <div className="w-full bg-gradient-to-r from-[#2F6FED] to-[#1E4FC7] overflow-hidden py-2.5 border-b border-[#3E5645]/10 shadow-sm">
      <div className="relative w-full overflow-hidden">
        <div
          ref={tickerRef}
          className="flex whitespace-nowrap gap-12"
          style={{ willChange: 'transform' }}
        >
          {allMessages.map((message, index) => (
            <span
              key={index}
              className="text-white text-sm font-medium px-2 flex items-center gap-2"
            >
              <span className="text-[#E8B84B] text-base">•</span>
              {message}
              <span className="text-[#E8B84B] text-base">•</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StoreTicker;